<div class="social-login row">
  <div
    class="col-12 social-login__wrapper"
    [class.social-login__wrapper--horizontal]="horizontalLayout()"
  >
    <button
      im-button
      class="inverted"
      (click)="onSocialLogin(socialLoginProvider.GOOGLE)"
    >
      <img iconStart src="/assets/images/socialLogin/Google_Logo.png" />
      @if (showText()) {
        <span class="pl10"> {{ 'social_login.google_l' | translate }} </span>
      }
    </button>
    <button
      im-button
      class="inverted"
      (click)="onSocialLogin(socialLoginProvider.APPLE)"
    >
      <img iconStart src="/assets/images/socialLogin/apple.svg" />
      @if (showText()) {
        <span class="pl10">
          {{ 'social_login.apple_signin' | translate }}
        </span>
      }
    </button>
  </div>
</div>
